import React from 'react';
import PropTypes from 'prop-types';
import {getSubFormFieldByType} from '../../util/methods';
import ComplaintModal from "../ComplaintModal";

class AssetServiceSubList extends React.Component {

  id = 0;

  state = {
    keys: [],
  };

  componentDidMount() {
    const { data = [] } = this.props;
    this.setState({
      keys: data,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        keys: nextProps.data,
      });
    }
  }

  // remove = index => {
  //   const { keys } = this.state;
  //   if (keys.length === 1) {
  //     return;
  //   }
  //
  //   keys.splice(index, 1);
  //   this.setState({
  //     keys: keys,
  //   });
  // };
  //
  // add = () => {
  //   const { item: { field } } = this.props;
  //   const { keys } = this.state;
  //   keys.push(`${field}${this.id++}`);
  //   this.setState({
  //     keys: keys,
  //   });
  // };

  render() {
    const { form, item, data = [], resource } = this.props;
    const { field } = item;
    const { getFieldDecorator } = form;
    const { keys } = this.state;

    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      marginBottom: '10px',
      borderRadius: '9px',
    };

    const formItems = keys.map((k, index) => (

      <div key={index} style={style}>
        {
          Object.keys(this.props.item.schema).map((fieldName, innerIndex) => {
            if (fieldName !== 'complaint') {
              return getSubFormFieldByType(item.schema[fieldName], getFieldDecorator, data[index], `${index}${innerIndex}`, field, index, { title: 'CREATE', resource });
            } else {
              return <ComplaintModal history={this.props.history} match={this.props.match} key={item} item={item} form={form} data={[]} getComplaintData={this.props.getComplaintData} complaints={this.props.complaints}/>
            }
          })
        }
      </div>
    ));

    return (
      <div>
        {formItems}
      </div>

    );
  }
}

export default AssetServiceSubList;
AssetServiceSubList.defaultProps = {};

AssetServiceSubList.propTypes = {
  item: PropTypes.object,
};
